/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Column,
  Row,
  Text,
  TEXT_VARIANTS,
  Tagline,
  Icon,
  IconNames,
  PersonCard,
  MemberCard,
  CollectionCard,
} from "../components";

const Notifications: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Column
      gap={50}
      css={css`
        width: 100%;
        max-width: 766px;
        padding: 0 10px 50px;
      `}
    >
      <Row mainAxisAlignment="space-between" crossAxisAlignment="center">
        <Button
          leadingElement={() => <Icon name={IconNames.Back} />}
          onClick={() => navigate(-1)}
        />
        <Text variant={TEXT_VARIANTS.T30}>{"Notifications"}</Text>
        <Button leadingElement={() => <Icon name={IconNames.Settings} />} />
      </Row>
      <Column>
        <div
          css={css`
            padding: 10px;
          `}
        >
          <Tagline
            text="$0 followed you 2h ago"
            entities={[{ type: "user", name: "Sari Azout" }]}
          />
        </div>
        <MemberCard />
      </Column>
      <Column>
        <div
          css={css`
            padding: 10px;
          `}
        >
          <Tagline
            text="$0 followed $1 2h ago"
            entities={[
              { type: "user", name: "Sari Azout" },
              { type: "collection", name: "Making Sublime" },
            ]}
          />
        </div>
        <MemberCard />
      </Column>
      <Column>
        <div
          css={css`
            padding: 10px;
          `}
        >
          <Tagline
            text="$0 connected to $1 2h ago"
            entities={[
              { type: "user", name: "Sari Azout" },
              { type: "collection", name: "Making Sublime" },
            ]}
          />
        </div>
        <PersonCard />
      </Column>
      <Column>
        <div
          css={css`
            padding: 10px;
          `}
        >
          <Tagline
            text="$0 connected to $1 2h ago"
            entities={[
              { type: "user", name: "Sari Azout" },
              { type: "tweet", name: "Tweet" },
            ]}
          />
        </div>
        <CollectionCard />
      </Column>
      <Column>
        <div
          css={css`
            padding: 10px;
          `}
        >
          <Tagline
            text="$0 connected to $1 2h ago"
            entities={[
              { type: "user", name: "Sari Azout" },
              { type: "article", name: "Ten Principles of Good Design" },
            ]}
          />
        </div>
        <CollectionCard />
      </Column>
      <Column>
        <div
          css={css`
            padding: 10px;
          `}
        >
          <Tagline
            text="$0 created a new collection 2h ago"
            entities={[{ type: "user", name: "Sari Azout" }]}
          />
        </div>
        <CollectionCard />
      </Column>
    </Column>
  );
};

export default Notifications;
